module.exports = __webpack_public_path__ + "static/media/stockhausen_blicke_52.271b3d82.jpg";